<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="13" r="1.5"/><path d="M21 16h-.53a8.81 8.81 0 00.53-3 1 1 0 001-1 9.94 9.94 0 00-2.26-6.32l.75-.76a1 1 0 00-1.41-1.41l-.76.75A9.94 9.94 0 0012 2H3a1 1 0 00-1 1v9.24A1 1 0 003 13a8.81 8.81 0 00.53 3H3a1 1 0 000 2h1.52a9 9 0 0015 0H21a1 1 0 000-2zm-1.06-5h-2a6 6 0 00-11.86 0h-2a8 8 0 0115.88 0zM4 4h2a10.27 10.27 0 00-2 2zm8 16a7 7 0 01-7-7h2a1 1 0 001-1 4 4 0 018 0 1 1 0 001 1h2a6.88 6.88 0 01-.69 3H8.5v2h8.39A7 7 0 0112 20z"/></svg>